import React, { createContext } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";
import { ThemeProvider } from "@mui/material";
import { theme } from "./theme";
import { BrowserRouter } from "react-router-dom";
import { AuthContextProvider } from "./store/auth-context";
import { LocaleContextProvider } from "./store/locale-context";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <LocaleContextProvider>
        <AuthContextProvider>
          <App />
        </AuthContextProvider>
      </LocaleContextProvider>
    </ThemeProvider>
  </BrowserRouter>
);
